export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <span className="text-xl font-bold font-heading text-primary-400 mb-3 block">51视频</span>
            <p className="text-xs text-white/55 leading-relaxed">
              聚合香蕉视频、红桃视频、91视频等热门影视资源，提供最新电影、电视剧、综艺免费在线观看，高清不卡顿不缓冲。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-xs text-white/55 hover:text-primary-400 transition-colors whitespace-nowrap">专题合集</a>
              <a href="#ranking" onClick={(e) => handleNavClick(e, '#ranking')} className="text-xs text-white/55 hover:text-primary-400 transition-colors whitespace-nowrap">热播排行榜</a>
              <a href="#cards" onClick={(e) => handleNavClick(e, '#cards')} className="text-xs text-white/55 hover:text-primary-400 transition-colors whitespace-nowrap">精选推荐</a>
              <a href="#features" onClick={(e) => handleNavClick(e, '#features')} className="text-xs text-white/55 hover:text-primary-400 transition-colors whitespace-nowrap">平台优势</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-3">更多内容</h4>
            <div className="flex flex-col gap-2">
              <a href="#updates" onClick={(e) => handleNavClick(e, '#updates')} className="text-xs text-white/55 hover:text-primary-400 transition-colors whitespace-nowrap">最新更新</a>
              <a href="#topics" onClick={(e) => handleNavClick(e, '#topics')} className="text-xs text-white/55 hover:text-primary-400 transition-colors whitespace-nowrap">热门话题</a>
              <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="text-xs text-white/55 hover:text-primary-400 transition-colors whitespace-nowrap">常见问题</a>
              <a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="text-xs text-white/55 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-3">合作伙伴</h4>
            <div className="flex flex-col gap-2">
              <span className="text-xs text-white/35">更多合作伙伴即将入驻</span>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/35">
            &copy; 2026 51视频 - 最新电影电视剧免费在线观看高清不卡顿不缓冲
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-white/35">影视大全 | 免费在线观看 | 高清不卡顿</span>
          </div>
        </div>
      </div>
    </footer>
  );
}